module.exports = __webpack_public_path__ + "img/secondary_1x1_z16.9811bd97.svg";